class Conditional {
    constructor(property, operator, value, unitSpecifier) {
        this.property = property;
        this.operator = operator;
        this.value = value;
        this.unitSpecifier = unitSpecifier;
    }

    hasProperty(property) {
        let contains = false;
        if (this.property === property) {
            contains = true;
        } else {
            if (Array.isArray(this.value) && this.property === "statement") {
                for (let i = 0; i < this.value.length; i++) {
                    const val = this.value[i];
                    if (val.hasProperty(property)) {
                        contains = true;
                        break;
                    }
                }
            }
        }
        return contains;
    }

    toString() {
        let out = "";

        if (this.property === "statement") {
            out = this.value
                .filter(v => v)
                .map(v => v.toString() + ".")
                .reduce((prev, curr) => prev + " " + this.operator + " " + curr);
            return out;
        }

        out += "" + this.property + " should ";
        const value = Array.isArray(this.value) ? this.value : [this.value];
        switch (this.operator) {
            case "!=":
                out += "not equal ";
                out += value.join(",");
                break;
            case "=":
                out += "equal ";
                out += value.join(",");
                break;
            case "||":
                out += "equal ";
                out += value.join(" or ");
                break;
            case "!||":
                out += "not equal ";
                out += value.join(" or ");
                break;
            case "~":
                out += "be in between ";
                out += value.join(" and ");
                break;
            case "!~":
                out += "not be in between ";
                out += value.join(" and ");
                break;
            default:
                break;
        }

        return out;
    }
}

module.exports = Conditional;
